import type { ReactNode } from 'react';
import { signOut, useTranslation } from '@dukanti/shared';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { supabase } from '@/lib/supabase';

interface AdminSignOutDialogProps {
  children: ReactNode;
  triggerClassName: string;
  triggerTestId: string;
  onConfirmStart?: () => void;
}

export function AdminSignOutDialog({
  children,
  triggerClassName,
  triggerTestId,
  onConfirmStart,
}: AdminSignOutDialogProps) {
  const { t } = useTranslation();

  const handleConfirm = () => {
    onConfirmStart?.();
    void signOut(supabase).finally(() => {
      window.location.assign('/auth/signin');
    });
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button
          type="button"
          data-testid={triggerTestId}
          className={triggerClassName}
          aria-label={t('admin.nav.signOut')}
        >
          {children}
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent data-testid="admin-sign-out-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{t('admin.nav.signOutDialog.title')}</AlertDialogTitle>
          <AlertDialogDescription>{t('admin.nav.signOutDialog.body')}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="admin-sign-out-cancel">
            {t('admin.nav.signOutDialog.cancel')}
          </AlertDialogCancel>
          <AlertDialogAction data-testid="admin-sign-out-confirm" onClick={handleConfirm}>
            {t('admin.nav.signOutDialog.confirm')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
